// Componente próprio pro campo tipo 'group_repeater' (form.blade.php). Não é uma
// variante do RepeaterList.js: aqui "Adicionar" clona a ÚLTIMA linha MANTENDO os
// valores (duplicar), em vez de limpar — por isso não reaproveita o componente
// existente, que é usado por outros forms e não pode mudar esse comportamento.
const GroupRepeaterList = function () {

    // Cada linha precisa de um name único (ex: campo[0][sub], campo[1][sub]) pro
    // jQuery Validation validar todas as linhas.
    const reindexClone = function (clone, index) {
        clone.find('[name]').each(function () {
            const el = $(this);
            el.attr('name', el.attr('name').replace(/\[\d+\]/, '[' + index + ']'));
        });
    }

    const revalidate = function (list) {
        const form = list.closest('form');

        if (form.length > 0 && typeof window._formValidade === 'function') {
            window._formValidade(form);

            // o _formValidade percorre o form INTEIRO e recoloca required fixo em todo campo;
            // então as regras condicionais precisam ser reaplicadas em todos os grupos (mercados),
            // não só no da linha que acabou de mudar.
            form.find('.js-group-repeater-list').each(function () {
                applyRules($(this));
            });
        }
    }

    // Combinação dos selects (categorias) da linha, ex. "22264|22266|2850". null se algum
    // select estiver vazio — nesse caso quem cobra é o 'required', não a duplicidade.
    const rowKey = function (row) {
        const values = row.find('select[data-repeater-field]').map(function () {
            return $(this).val();
        }).get();

        return values.length === 0 || values.some(function (value) { return !value; }) ? null : values.join('|');
    }

    let uniqueMethodRegistered = false;
    const registerUniqueMethod = function () {
        if (uniqueMethodRegistered || typeof $.validator === 'undefined') {
            return;
        }

        $.validator.addMethod('groupRowUnique', function (value, element) {
            const row = $(element).closest('.js-group-repeater-row');
            const key = rowKey(row);

            if (key === null) {
                return true;
            }

            return row.siblings('.js-group-repeater-row').filter(function () {
                return rowKey($(this)) === key;
            }).length === 0;
        }, 'Já existe outra linha com esta mesma combinação.');

        uniqueMethodRegistered = true;
    }

    // A regra fica só no 1º select de cada linha pra mensagem aparecer uma vez por linha
    // (e não uma por select). Como o jQuery Validation só revalida o campo que mudou,
    // revalidateUnique() reavalia todas as linhas quando qualquer select muda.
    const applyUniqueRule = function (list) {
        registerUniqueMethod();

        if (uniqueMethodRegistered === false || typeof $.fn.rules !== 'function') {
            return;
        }

        list.find('.js-group-repeater-row').each(function () {
            $(this).find('select[data-repeater-field]').first().rules('add', { groupRowUnique: true });
        });
    }

    // Linha com algum campo preenchido (hidden não conta; checkbox conta se marcado).
    const rowHasValue = function (row) {
        return row.find('select, input').not('[type="hidden"]').filter(function () {
            return $(this).is('[type="checkbox"]') ? $(this).is(':checked') : !!$(this).val();
        }).length > 0;
    }

    // O required de select do _formValidade (valueNotEquals 'Selecione...') nunca falha,
    // porque o placeholder tem value vazio. Aqui o required do jQuery Validation vira
    // condicional: só cobra os campos de uma linha que tenha algo preenchido — a linha em
    // branco (mercado sem registro) não trava o save.
    const applyRequiredRule = function (list) {
        if (typeof $.fn.rules !== 'function') {
            return;
        }

        list.find('[data-validate]').each(function () {
            const el = $(this);
            const validate = el.data('validate');
            const isRequired = Array.isArray(validate) && validate.some(function (item) { return item.validate === 'required'; });

            if (!isRequired) {
                return;
            }

            el.rules('remove', 'required valueNotEquals');
            el.rules('add', {
                required: function (element) {
                    return rowHasValue($(element).closest('.js-group-repeater-row'));
                },
                messages: { required: 'Este campo é obrigatório.' }
            });
        });
    }

    // either_or (data-either-or na lista, vindo do config do grupo): pares [campoA, campoB] em que
    // exatamente um deve estar preenchido. Pares checkbox + campo: marcar o checkbox limpa o campo;
    // preencher o campo desmarca o checkbox — assim os dois nunca coexistem na tela.
    const eitherOrPairs = function (list) {
        try {
            return JSON.parse(list.attr('data-either-or') || '[]');
        } catch (e) {
            return [];
        }
    }

    const fieldOf = function (row, name) { return row.find('[data-repeater-field="' + name + '"]'); }

    // { checkbox, other } de um par, ou null se o par não for checkbox + campo
    const splitPair = function (row, pair) {
        const first = fieldOf(row, pair[0]);
        const second = fieldOf(row, pair[1]);

        if (first.is('[type="checkbox"]') && second.length > 0) {
            return { checkbox: first, other: second };
        }

        return second.is('[type="checkbox"]') && first.length > 0 ? { checkbox: second, other: first } : null;
    }

    const applyEndRule = function (list) {
        if (typeof $.fn.rules !== 'function') {
            return;
        }

        list.find('.js-group-repeater-row').each(function () {
            const row = $(this);

            eitherOrPairs(list).forEach(function (pair) {
                const parts = splitPair(row, pair);

                if (parts === null) {
                    return;
                }

                parts.other.rules('remove', 'required');
                parts.other.rules('add', {
                    required: function () { return rowHasValue(row) && !parts.checkbox.is(':checked'); },
                    messages: { required: 'Preencha este campo ou marque a opção ao lado.' }
                });
            });
        });
    }

    const onEitherOrChange = function (event) {
        const el = $(event.currentTarget);
        const row = el.closest('.js-group-repeater-row');
        const list = row.closest('.js-group-repeater-list');
        const name = el.attr('data-repeater-field');

        eitherOrPairs(list).forEach(function (pair) {
            const parts = pair.indexOf(name) === -1 ? null : splitPair(row, pair);

            if (parts === null) {
                return;
            }

            if (el.is('[type="checkbox"]') && el.is(':checked')) {
                parts.other.val('');
            } else if (!el.is('[type="checkbox"]') && el.val()) {
                parts.checkbox.prop('checked', false);
            }
        });

        revalidateRow(row);
    }

    const applyRules = function (list) {
        applyRequiredRule(list);
        applyEndRule(list);
        applyUniqueRule(list);
    }

    const revalidateUnique = function (list) {
        if (uniqueMethodRegistered === false) {
            return;
        }

        list.find('.js-group-repeater-row').each(function () {
            const first = $(this).find('select[data-repeater-field]').first();

            if (first.length > 0) {
                first.valid();
            }
        });
    }

    // Revalida os obrigatórios da linha quando qualquer campo muda: preencher dispara os erros
    // dos demais; esvaziar tudo limpa os que já estavam na tela.
    const revalidateRow = function (row) {
        row.find('[data-validate], [data-repeater-field]').each(function () {
            $(this).valid();
        });
    }

    const onSelectChange = function (event) {
        revalidateRow($(event.currentTarget).closest('.js-group-repeater-row'));
        revalidateUnique($(event.currentTarget).closest('.js-group-repeater-list'));
    }

    // Clona uma linha. keepValues=true (duplicar) mantém o que foi escolhido; false
    // ("Adicionar") parte de uma linha em branco.
    const cloneRow = function (list, source, keepValues) {
        const clone = source.clone();
        const nextIndex = parseInt(list.attr('data-group-repeater-next-index'), 10) || 0;

        // .clone() não copia o estado dinâmico do <select> (valor escolhido pelo usuário) nem
        // o .data('all-options') do cascade. Copiamos o cache e, na linha em branco, voltamos
        // pra lista COMPLETA de options (a da origem pode já estar filtrada pelo Mercado).
        source.find('select').each(function () {
            const target = clone.find('select[data-repeater-field="' + $(this).attr('data-repeater-field') + '"]');
            const allOptions = $(this).data('all-options');

            if (allOptions !== undefined) {
                target.data('all-options', allOptions.clone());

                if (!keepValues) {
                    target.empty().append(allOptions.clone());
                }
            }

            if (keepValues) {
                target.val($(this).val());
            } else {
                target.prop('selectedIndex', 0);
            }
        });

        if (!keepValues) {
            clone.find('input').not('[type="hidden"], [type="checkbox"]').val('');
            clone.find('input[type="checkbox"]').prop('checked', false);
        }

        reindexClone(clone, nextIndex);
        // zera só o id oculto da linha original — senão o save reconhece a cópia
        // como a MESMA linha (products_groups.id) em vez de criar uma nova.
        clone.find('[data-repeater-field="id"]').val('');

        // o data-callback-field embute o name indexado do campo-alvo (ex.: [3][channel]);
        // sem reindexar aqui, a cópia continuaria apontando o cascade pro campo da
        // linha ORIGINAL em vez do seu próprio.
        clone.find('[data-callback-field]').each(function () {
            const el = $(this);
            el.attr('data-callback-field', el.attr('data-callback-field').replace(/\[\d+\]/g, '[' + nextIndex + ']'));
        });

        if (keepValues) {
            source.after(clone);
        } else {
            list.append(clone);
        }
        list.attr('data-group-repeater-next-index', nextIndex + 1);

        revalidate(list);
        // só registra a regra: a cópia duplicada nasce igual à original de propósito, então o
        // erro de duplicidade aparece quando o usuário mexer num select ou tentar salvar.
        applyRules(list);
    }

    const addRow = function (event) {
        const list = $(event.currentTarget).parent().find('.js-group-repeater-list').first();

        if (list.length === 0) {
            return;
        }

        cloneRow(list, list.find('.js-group-repeater-row').last(), false);
    }

    const duplicateRow = function (event) {
        const source = $(event.currentTarget).closest('.js-group-repeater-row');

        cloneRow(source.closest('.js-group-repeater-list'), source, true);
    }

    const removeRow = function (event) {
        const row = $(event.currentTarget).closest('.js-group-repeater-row');
        const list = row.closest('.js-group-repeater-list');

        if (list.find('.js-group-repeater-row').length <= 1) {
            // sempre precisa sobrar 1 linha: é o template clonado pelo "Adicionar"
            row.find('select').prop('selectedIndex', 0);
            row.find('input:not([type="hidden"], [type="checkbox"])').val('');
            row.find('input[type="checkbox"]').prop('checked', false);
            row.find('[data-repeater-field="id"]').val('');
        } else {
            row.remove();
        }

        revalidateUnique(list);
    }

    // Precisa rodar de novo toda vez que HTML novo é injetado via AJAX (troca de
    // step do produto) — por isso fica exposta em window, igual _repeaterListInit.
    const initAllLists = function () {
        $('.js-group-repeater-list').each(function () {
            revalidate($(this));
            // .rules('add') exige que .validate() já tenha rodado no form (revalidate acima)
            applyRules($(this));
        });
    }

    window._groupRepeaterListInit = initAllLists;

    return {
        init: function () {
            $(document).on('click', '.js-group-repeater-add', addRow);
            $(document).on('click', '.js-group-repeater-duplicate', duplicateRow);
            $(document).on('click', '.js-group-repeater-remove', removeRow);
            $(document).on('change', '.js-group-repeater-list[data-either-or] input', onEitherOrChange);
            $(document).on('change', '.js-group-repeater-list input', function (event) {
                revalidateRow($(event.currentTarget).closest('.js-group-repeater-row'));
            });
            $(document).on('change', '.js-group-repeater-list select[data-repeater-field]', onSelectChange);

            $(function () {
                initAllLists();
            });
        }
    }
}();

module.exports = GroupRepeaterList;
